<div class="app-shell">

  <app-notifications></app-notifications>

  @if (showHeader()) {
    <app-header
      [userName]="topBarUserName"
      [userRole]="topBarRole"
      [profilePic]="headerProfilePic"
      [showEditor]="showEditor()"
      [contractState]="contractState"/>
  }

  @if (showMenu()) {
    <sidebar-menu/>
  }

  <main class="hc-main"
        [class.no-header]="!showHeader()"
        [class.no-sidebar]="!showMenu()"
        [class.sidebar-collapsed]="sidebar.collapsed()"
        role="main">
    <router-outlet></router-outlet>
  </main>

</div>
